export const removeHtmlTags = (html: string): string => html.replace(/(<([^>]+)>)/gi, '');
